import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';

import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import LifeCycleRateForm from '../../components/LifeCycle/RateForm';

const LifeCycleForm = ({classes, lifeCycleRate}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('life_cycle.title')}
        />

        <div className={classes.layout}>
            <Paper className={classes.paper}>
                {lifeCycleRate ? (
                    /* Edit a already existing life cycle rate */
                    <LifeCycleRateForm
                        method="PUT"
                        url={`/life-cycle-rates/${lifeCycleRate.id}`}
                        values={lifeCycleRate}
                    />
                ) : (
                    /* Create a new life cycle rate */
                    <LifeCycleRateForm
                        method="POST"
                        url="/life-cycle-rates"
                    />
                )}
            </Paper>
        </div>
    </Layout>
);

const styles = theme => ({
    layout: {
        width: 'auto',
        marginLeft: theme.spacing.unit * 2,
        marginRight: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 2 * 2)]: {
            width: 600,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
});

export default withStyles(styles)(LifeCycleForm);



// WEBPACK FOOTER //
// ./resources/assets/js/pages/lifeCycle/Form.jsx